import dayjs from 'dayjs';
import { mixed, object, ObjectSchema, string } from 'yup';

import { CustomerFlagDto, CustomerStatusDto } from '@/api/generated';
import {
  selectSearchOptionRequiredFieldsValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { CreateBusinessCustomerFormModel } from '@/views/customers/createBusiness/model/CreateBusinessCustomerForm.model.ts';

export const useCreateBusinessCustomerFormValidation =
  (): ObjectSchema<CreateBusinessCustomerFormModel> => {
    const { t } = useTranslationWithPrefix('validation');

    return object().shape({
      community: string().nullable(),
      county: string().nullable(),
      flag: selectSearchOptionRequiredValidation<CustomerFlagDto>(string(), t),
      flatNo: string().nullable(),
      foundingDate: mixed<dayjs.Dayjs>().nullable(),
      houseNo: string().nullable(),
      locality: string().nullable(),
      name: string().required(t('general.required')),
      nip: string().required(t('general.required')),
      postCode: string().nullable(),
      province: string().nullable(),
      regon: string().required(t('general.required')),
      // hidden from creators without CUSTOMER_APPROVE, so the backend creates a Prospekt
      status: selectSearchOptionRequiredFieldsValidation<CustomerStatusDto>(string(), t).nullable(),
      street: string().nullable(),
    });
  };
